export default "<p>Logging in...</p>\r\n"